import { Injectable, ErrorHandler, Injector } from '@angular/core';
import { AppInsightService } from './shared/services/app-insight.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

    constructor(private injector: Injector) { }

    handleError(error: any) {
        // tslint:disable-next-line: no-console
        console.trace(error);
        const appInsights = this.injector.get(AppInsightService);

        return appInsights.logError(error);
    }
}